// extracted by mini-css-extract-plugin
module.exports = {"readMoreLess":"HasTruncation_readMoreLess__2xjJm"};